export default __webpack_public_path__ + "static/media/back_button.5140cf88.svg";